import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {jwtDecode} from 'jwt-decode'; // Fixed import for jwt-decode
import { alertActions } from '_store';
import { history, fetchWrapper } from '_helpers';

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

function createInitialState() {
    return {
        value: JSON.parse(localStorage.getItem('auth')),
        error: null,
        successMessage: null, // Add this line for success messages
    };
}

function createReducers() {
    return {
        setAuth,
        setSuccessMessage,
        setError,
        
    };

    function setAuth(state, action) {
        state.value = action.payload;
    }

    function setSuccessMessage(state, action) {
        state.successMessage = action.payload;
        state.error = null; 
    }

    function setError(state, action) {
        state.error = action.payload;
        state.successMessage = null; 
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    return {
        login: login(),
        logout: logout(),
        forgotPassword: forgotPassword(),
        resetPassword: resetPassword(), // Correctly integrated resetPassword
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async function ({ email, password }, { dispatch }) {
                dispatch(alertActions.clear());
                try {
                    const user = await fetchWrapper.post(`${baseUrl}/authenticate`, { email, password });

                    // Decode the token to get expiration time
                    const decodedToken = jwtDecode(user.token);
                    const expirationTime = decodedToken.exp * 1000; // Convert from seconds to milliseconds

                    // Store user details, token, and expiration time in local storage
                    localStorage.setItem('auth', JSON.stringify({
                        ...user,
                        expirationTime
                    }));

                    localStorage.setItem('user', JSON.stringify(user.user || user));

                    // Set auth user in Redux state (without expirationTime)
                    dispatch(authActions.setAuth({
                        ...user,
                        token: user.token // Only store token and user details
                    }));

                    // Get return URL from location state or default to home page
                    const { from } = history.location.state || { from: { pathname: '/' } };

                    const pendingJobId = localStorage.getItem('pendingJobId');
if (pendingJobId) {
    // User has a pending job, redirect to dashboard
    history.navigate('/home', { replace: true });
} else {
    // No pending job, use normal redirect logic
    history.navigate(from);
}
                    history.navigate(from);
                } catch (error) {
                    // Ensure that only serializable values are dispatched
                    dispatch(alertActions.error(error));
                }
            }
        );
    }

    function logout() {
        return createAsyncThunk(
            `${name}/logout`,
            async function (_, { dispatch }) {
                try {
                    await fetchWrapper.post(`${baseUrl}/logout`);
                } catch (error) {
                    console.error('Logout error:', error);
                }
                dispatch(authActions.setAuth(null));
                localStorage.removeItem('auth');
                window.location.href = '/';
            }
        );
    }

    // function forgotPassword() {
    //     return createAsyncThunk(
    //         `${name}/forgotPassword`,
    //         async function ({ email }, { dispatch }) {
    //             try {
    //                 await fetchWrapper.post(`${baseUrl}/forgot-password`, { email });
    //                 dispatch(alertActions.success('Reset link sent to your email.'));
    //             } catch (error) {
    //                 dispatch(alertActions.error('Failed to send reset link.'));
    //             }
    //         }
    //     );
    // }

    function forgotPassword() {
        
    return createAsyncThunk(
        `${name}/forgotPassword`,
        async function ({ email }, { dispatch, rejectWithValue }) {
            try {
                // We capture the response from the fetchWrapper
                const response = await fetchWrapper.post(`${baseUrl}/forgot-password`, { email });

                // If your API returns a 200 message, you can use it here
                dispatch(alertActions.success(response.message || 'Reset link sent to your email.'));
                return response;
            } catch (error) {
                // --- THE FIX ---
                // 1. Get the message from the API (e.g., "You are a Google user...")
                // Depending on your fetchWrapper, it's usually error or error.message
                const errorMessage = error || 'Failed to send reset link.';

                // 2. Dispatch the actual message to your alert system
                dispatch(alertActions.error(errorMessage));

                // 3. Reject with the value so the component's .catch() also sees it
                return rejectWithValue(errorMessage);
            }
             }
    );
}

    function resetPassword() {
        return createAsyncThunk(
            `${name}/resetPassword`,
            async function ({ email, token, password }, { dispatch }) {
                dispatch(alertActions.clear());
                try {
                    const response = await fetchWrapper.post(`${baseUrl}/reset-password`, { email, token, new_password: password });
                    if (response.message) {
                        return response;
                    } else {
                        throw new Error('Password reset failed.');
                    }
                } catch (error) {
                    dispatch(alertActions.error(error));
                    throw error; // Ensure error is thrown for `.catch` to handle
                }
            }
        );
    }
}    
